import React from 'react';
import Star from 'components/icons/star';

export type StarIconVariant = 'filled' | 'empty' | 'disabled-empty';
export type StrokeVariant = 'matching' | 'gray';

export interface StarIconProps {
  variant?: StarIconVariant;
  strokeVariant?: StrokeVariant;
  size?: number;
  fillColor?: string;
  strokeColor?: string;
  className?: string;
  ariaLabel?: string;
}

export const StarIcon: React.FC<StarIconProps> = ({
  variant = 'empty',
  strokeVariant = 'matching',
  size = 40,
  className = '',
  ariaLabel,
}) => {
  const accessibilityLabel =
    ariaLabel ||
    (variant === 'filled' ? 'Filled Star' : variant === 'disabled-empty' ? 'Disabled Empty Star' : 'Empty Star');

  const fillClass =
    variant === 'filled' ? 'fill-star' : variant === 'disabled-empty' ? 'fill-stroke-primary' : 'fill-none';

  const strokeClass = variant === 'filled' && strokeVariant === 'matching' ? 'stroke-star' : 'stroke-stroke-primary';

  return <Star size={size} className={`${fillClass} ${strokeClass} ${className}`} ariaLabel={accessibilityLabel} />;
};

export default StarIcon;
